import { WarningCircleIcon, WarningIcon, XIcon } from '@phosphor-icons/react';
import classNames from 'classnames';
import React, { useState } from 'react';
import s from './Alert.module.scss';

type Severity = 'warning' | 'error';
type Position = 'top' | 'bottom';

interface AlertProps {
  message: string;
  severity: Severity;
  dismissable?: boolean;
  actionButton?: React.ReactNode;
  position?: Position;
}

export const Alert: React.FC<AlertProps> = (props: AlertProps) => {
  const [isVisible, setIsVisible] = useState(true);
  const position = props.position ?? 'bottom';

  const handleClose = () => {
    setIsVisible(false);
  };

  if (!isVisible) return null;

  const getIcon = () => {
    switch (props.severity) {
      case 'error':
        return <WarningIcon weight="fill" className={s.icon} />;
      case 'warning':
        return <WarningCircleIcon weight="fill" className={s.icon} />;
    }
  };

  return (
    <div className={classNames(s.container, s[props.severity], s[position])} data-dismissed={!isVisible}>
      <div className={s.content}>
        {getIcon()}
        <div className={s.message}>{props.message}</div>
        {props.actionButton && <div className={s.actionButton}>{props.actionButton}</div>}
        {props.dismissable && <XIcon onClick={handleClose} className={s.dismissButton} size={16} weight="bold" />}
      </div>
    </div>
  );
};
